import { stringifyEntityRef } from '@backstage/catalog-model';
import { Content } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { usePermission } from '@backstage/plugin-permission-react';
import Box from '@material-ui/core/Box';
import { keyvaultSecretWritePermission } from '@internal/backstage-plugin-keyvault-secrets-common';
import { secretStages } from '../availability';
import { StageSecretsCard } from './StageSecretsCard';

/** One card per stage the entity has a `key-vault-<stage>` annotation for.
 * The permission only hides buttons; the backend is the control. */
export const EntityKeyVaultSecretsContent = () => {
  const { entity } = useEntity();
  const entityRef = stringifyEntityRef(entity);
  const canWrite = usePermission({ permission: keyvaultSecretWritePermission }).allowed;

  return (
    <Content>
      <Box display="grid" gridGap={16}>
        {secretStages(entity).map(stage => (
          <StageSecretsCard
            key={stage}
            entityRef={entityRef}
            stage={stage}
            canWrite={canWrite}
          />
        ))}
      </Box>
    </Content>
  );
};
